import { CheckCircle, X } from '@tamagui/lucide-icons';
import { NoData } from '@unistocks/components/no-data/no-data';
import { Page } from '@unistocks/components/page/page';
import { Anchor } from '@unistocks/components/text/link';
import { t } from '@unistocks/shared/localization/index.ts';
import { style } from '@unistocks/shared/styles';
import { isTrue } from '@unistocks/shared/utils/util';
import { Link } from 'expo-router';
import React from 'react';
import { useMedia } from 'tamagui';

type EmailConfirmationProps = {
  success: string;
};

export const EmailConfirmation: React.FC<EmailConfirmationProps> = ({ success }) => {
  const media = useMedia();
  const isSuccess = isTrue(success);
  const message = isSuccess
    ? t('::YourEmailAddressIsSuccessfullyConfirmed')
    : t('::YourEmailAddressCouldNotBeConfirmed');

  return (
    <Page.ScrollView
      headerTransparent
      headerLogo={false}
      headerTitle={t('::EmailConfirmation')}
      contentContainerStyle={media['max-md'] ? style.centerVertical : undefined}
    >
      <Page.Content justifyContent={'center'}>
        <NoData
          size={'$7'}
          Icon={isSuccess ? CheckCircle : X}
          color={isSuccess ? '$success' : '$danger'}
          text={message}
        />

        <Link asChild dismissTo href={'/(auth)/login'}>
          <Anchor size={'$5'} mt={'$3'} mx={'auto'}>
            {isSuccess ? t('AbpAccount::Login') : t('AbpAccount::BackToLogin')}
          </Anchor>
        </Link>
      </Page.Content>
    </Page.ScrollView>
  );
};

EmailConfirmation.displayName = 'EmailConfirmation';
